module.exports = __webpack_public_path__ + "img/block.73c3200.svg";